import { Hero } from '@/components/Hero';
import { HowItWorks } from '@/components/HowItWorks';
import { GetHired } from '@/components/GetHired.tsx';
import { CommonQuestions } from '@/components/CommonQuestions';
import { ApplyForm } from '@/components/ApplyForm';
import { Layout } from '@/components/Layout';

const LandingPage = () => {
  return (
    <Layout>
      <div className="flex flex-col w-full max-w-md">
        <Hero />
        <HowItWorks />
        <GetHired />
        <CommonQuestions />
        <ApplyForm />
      </div>
    </Layout>
  );
};

export default LandingPage;
